// Force every `/en` and `/de` page to its Czech equivalent. The `en`/`de`
// locales themselves stay registered (content mutations / translations keep
// working) — only URL access to the non-Czech routes is redirected. Browser
// language detection is already off (i18n.detectBrowserLanguage: false in
// nuxt.config), so visiting `/en…` or `/de…` directly is the only way to land here.
//
// HOW TO SAFELY RE-ENABLE A LOCALE (let its pages render again):
//   1. Remove its code from DISABLED_LOCALES below (delete this file to enable
//      all) — locales are never removed from i18n.locales in nuxt.config, so
//      the routes already exist and resolve.
//   2. Confirm the locale is still listed in BOTH places in nuxt.config.ts:
//        - i18n.locales            (URL routing: { code: 'en', language: 'en-GB' })
//        - sharedComponents.options.i18n.locales ({ en: 'en_GB' } -> backend locale)
//      If someone removed them while disabling, add them back first.
//   3. SEO follow-ups for the re-enabled locale:
//        - app.vue: stop filtering its hreflang alternates (i18nLinks/i18nMeta)
//        - nuxt.config sitemap.exclude: remove its URL prefix
//        - server/routes/fe/api/__sitemap__/urls.ts: add its paths + alternatives
//   4. (Optional) Browser auto-detect is a SEPARATE decision: leave
//      i18n.detectBrowserLanguage `false` unless you want it.
//   5. Verify: `curl -I http://localhost:3000/en/login` returns 200, not 301.
const DISABLED_LOCALES = ['en', 'de']

export default defineNuxtRouteMiddleware((to) => {
  const name = String(to.name ?? '')
  // Route names are `<base>___<locale>` (default i18n separator).
  if (!DISABLED_LOCALES.some((locale) => name.endsWith(`___${locale}`))) return

  const getRouteBaseName = useRouteBaseName()
  const localePath = useLocalePath()

  const base = getRouteBaseName(to)
  if (!base) return

  // Resolve the same route under `cs`, preserving params/query/hash. localePath
  // maps custom localized paths too (e.g. /en/login -> /prihlaseni).
  const target = localePath(
    { name: base, params: to.params, query: to.query, hash: to.hash },
    'cs'
  )

  if (target && target !== to.fullPath) {
    return navigateTo(target, { redirectCode: 301, replace: true })
  }
})
